import React from 'react';
import { Row } from 'react-bootstrap';
import { Button as SubmitButton } from '../../util/buttons';
import { useTranslation } from 'react-i18next';
const ClaimGroupEditFooter = _ref => {
  let {
    loading,
    handleSubmit,
    isUnderReview
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Row, {
    className: "modal-footer"
  }, /*#__PURE__*/React.createElement(SubmitButton, {
    isImmutableUnderReview: true,
    disabled: isUnderReview,
    loading: loading,
    onClick: handleSubmit,
    variant: "primary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "save"), " ", t('save')));
};
export default ClaimGroupEditFooter;